export default __webpack_public_path__ + "static/media/dinamani.eb6e839c.jpg";